import React from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';

import Login from '../pages/authentication/login';
import ResetPassword from '../pages/authentication/resetPassword';
import MfaVerification from '../pages/authentication/mfaVerification';
import UpdatePassword from '../pages/authentication/updatePassword';
import MfaList from '../pages/registration/registration';
import QRCodeAndPasswordSet from '../pages/registration/pages/userRegister';
import Error404 from '../components/common/error404';
import { AUTH_ROUTES } from './RouteConstants';

import { applyErrorBoundary } from '../util/error/ErrorBoundary';

const AllRoutes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path={AUTH_ROUTES.login} component={applyErrorBoundary(Login)} />
        <Route
          exact
          path={AUTH_ROUTES.resetPassword}
          component={applyErrorBoundary(ResetPassword)}
        />
        <Route
          exact
          path={AUTH_ROUTES.updatePassword}
          component={applyErrorBoundary(UpdatePassword)}
        />

        <Route exact path={AUTH_ROUTES.otpPage} component={applyErrorBoundary(MfaVerification)} />

        <Route
          exact
          path={AUTH_ROUTES.newUserRegistration}
          component={applyErrorBoundary(MfaList)}
        />
        <Route
          exact
          path={`${AUTH_ROUTES.qrCodeAndPasswordSet}/:name`}
          component={applyErrorBoundary(QRCodeAndPasswordSet)}
        />

        <Route
          exact
          path={AUTH_ROUTES.home}
          // eslint-disable-next-line no-unused-vars
          render={props => <Redirect to={AUTH_ROUTES.login} />}
        />
        <Route path="*" component={Error404} />
      </Switch>
    </BrowserRouter>
  );
};

export default AllRoutes;
